import React from "react";
import NavBar from "../../components/navBar/NavBar";
import CardTaskDescriptions from "../../components/card/CardDescriptions";
import "../../assets/style/style.css";
import axios from "axios";
import io from "socket.io-client";

const url = process.env.REACT_APP_API_TASK;
const urlSocket = process.env.REACT_APP_API_SOCKET;
const socket = io(urlSocket);
class TaskDescriptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id_memorial: null,
      idTaskDescription: null,
      idViabilidade: null,
      idFormularioTecnico: null
    };
  }

  componentDidMount = () => {
    //this.getAtividade(this.props.match.params.id);
    this.socketStart();
    const tokenLocal = localStorage.getItem("token");

    this.getAtividade(this.props.match.params.id, tokenLocal);

    this.getTaskMemorial(this.props.match.params.id, tokenLocal);

    this.setState({
      idTaskDescription: this.props.match.params.id
    });
  };

  socketStart = () => {
    socket.on("newTask", msg => {
      this.getAtividade(
        this.props.match.params.id,
        localStorage.getItem("token")
      );
    });
  };

  getFormularioTecnico = async (idViabilidade, token) => {
    const objForm = {
      idViabilidade: idViabilidade,
      token: token
    };
    const response = await axios.post(`${url}/getFormularioTecnico`, {
      objForm: objForm
    });

    if (response.data.resultFormulario.length > 0 && idViabilidade > 0) {
      this.setState({
        idViabilidade: idViabilidade,
        idFormularioTecnico: response.data.resultFormulario[0].id
      });
    }
  };

  getTaskMemorial = async (id, token) => {
    const objForm = {
      id: id,
      token: token
    };

    const responseMemorial = await axios.post(`${url}/memorial_by_atividade`, {
      objForm: objForm
    });

    if (responseMemorial.data.length > 0) {
      this.setState({
        id_memorial: responseMemorial.data[0].id
      });
      if (responseMemorial.data.possuiMemorial !== "nao") {
        if (
          responseMemorial.data[0].aprovado === "sim" &&
          responseMemorial.data[0].aprovado_gerente_operacional === "sim"
        ) {
          this.setState({
            memorialStatus: "concluido"
          });
        } else {
          this.setState({
            memorialStatus: "pendente"
          });
        }
      }
    }
  };

  getAtividade = async (id, token) => {
    const objForm = { id: id, token: token };
    const responseAtividade = await axios.post(`${url}/atividade_cliente`, {
      objForm: objForm
    });

    this.setState({
      status: this.Capitalize(responseAtividade.data.rat_client[0].status),
      idRatPop: responseAtividade.data.rat_client[0].id,
      empresa: responseAtividade.data.rat_client[0].empresa,
      idViabilidade: responseAtividade.data.rat_client[0].id_viabilidade,
      pop: responseAtividade.data.rat_client[0].pop,
      atividade: responseAtividade.data.rat_client[0].atividade
    });

    this.getFormularioTecnico(
      responseAtividade.data.rat_client[0].id_viabilidade,
      token
    );
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast="/task" />
        <div className="container-fluid container_body">
          <div className="containerCard">
            {this.state.memorialStatus === "concluido" &&
              this.state.empresa && (
                <CardTaskDescriptions
                  status="Concluído"
                  title="Memorial"
                  way={
                    "/memorial/" +
                    this.state.idTaskDescription +
                    "/" +
                    this.state.id_memorial
                  }
                />
              )}

            {this.state.memorialStatus === "pendente" && this.state.empresa && (
              <CardTaskDescriptions status="Pendente" title="Memorial" />
            )}

            {this.state.empresa && (
              <CardTaskDescriptions
                status={this.state.status}
                title="Rat Cliente"
                way={"/activity-client/" + this.state.idRatPop}
              />
            )}

            {this.state.idFormularioTecnico && (
              <CardTaskDescriptions
                status="Concluido"
                title="Informações Técnicas"
                way={
                  "/form-client/" +
                  this.state.idRatPop +
                  "/" +
                  this.state.idViabilidade
                }
              />
            )}

            {this.state.pop && (
              <CardTaskDescriptions
                status={this.state.status}
                title="Rat POP"
                way={"/activity-pop/" + this.state.idRatPop}
              />
            )}

            {this.state.atividade && (
              <CardTaskDescriptions
                status={this.state.status}
                title="Rat Atividade Interna"
                way={"/activity-all/" + this.state.idRatPop}
              />
            )}

            <CardTaskDescriptions
              status="Andamento"
              title="Solicitar Equipamento"
              way={"/equipaments/" + this.state.idRatPop}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TaskDescriptions;
